import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { UserIdleService } from 'angular-user-idle';
import { MasterDataHttpService } from './shared/services/master-data-http.service';
import { Store } from '@ngrx/store';
import { setCurrencyList } from './shared/state/actions/currency.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'clientApp';
  returnUrl!: string;
  isIframe = false;
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();
  routerSubscription: Subscription;
  timerStartSubscription: Subscription | null = null;
  timeoutSubscription: Subscription | null = null;

  constructor(
    private userIdle: UserIdleService,
    public router: Router,
    private masterDataHttpService: MasterDataHttpService,
    private store: Store,
  ) {}

  ngOnInit(): void {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url === '/login') {
          this.stopUserIdle();
        } else {
          this.startUserIdle();
        }
      }
    });
    this.isIframe = window !== window.parent && !window.opener;
    this.getBanksCurrencies();
  }

  private getBanksCurrencies() {
    this.masterDataHttpService.getBanksCurrencies().subscribe({
      next: (res) => {
        this.store.dispatch(setCurrencyList({ currencyList: res }));
      },
    });
  }

  startUserIdle(): void {
    this.userIdle.startWatching();
    this.timeoutSubscription = this.userIdle.onTimeout().subscribe(() => {
      if (!this.isRememberMe()) {
        this.logout();
      }
    });
  }

  stopUserIdle(): void {
    this.userIdle.stopWatching();
    this.timerStartSubscription?.unsubscribe();
    this.timerStartSubscription = null;
    this.timeoutSubscription?.unsubscribe();
    this.timeoutSubscription = null;
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  isRememberMe(): boolean {
    const rememberMeValue = localStorage.getItem('rememberMe');
    if (rememberMeValue !== null) {
      return JSON.parse(rememberMeValue);
    }
    return false;
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
